export class TeklifKalemGirRequest {

  teklifKalemId: number;
  talepKalemId: number;
  birimFiyati: number;
  paraBirimiId: number;

  constructor(obj?: any) {
    if (obj == null) {
      return;
    }
    Object.assign(this, obj);
  }
}
